export default __webpack_public_path__ + "static/TIMBERLINE-S-SERIES-20-O-front-WEB-0bf66ca9fe252ecd87e2a4dc11ce1a19.png";